var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 8.00001C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00001C1.33325 4.31811 4.31802 1.33334 7.99992 1.33334C11.6818 1.33334 14.6666 4.31811 14.6666 8.00001ZM6.28302 5.7171C6.12681 5.56089 5.87355 5.56089 5.71734 5.7171C5.56113 5.87331 5.56113 6.12658 5.71734 6.28279L7.43449 7.99995L5.71734 9.7171C5.56113 9.87331 5.56113 10.1266 5.71734 10.2828C5.87355 10.439 6.12681 10.439 6.28302 10.2828L8.00018 8.56563L9.71734 10.2828C9.87355 10.439 10.1268 10.439 10.283 10.2828C10.4392 10.1266 10.4392 9.87331 10.283 9.7171L8.56586 7.99995L10.283 6.28279C10.4392 6.12658 10.4392 5.87331 10.283 5.7171C10.1268 5.56089 9.87355 5.56089 9.71734 5.7171L8.00018 7.43426L6.28302 5.7171Z",
    fill: "#979998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.9b0d264796594528f18048ea7415c2ef.svg";
export { ForwardRef as ReactComponent };